import { render, staticRenderFns } from "./BtnMyTeam.vue?vue&type=template&id=045a65db&scoped=true"
import script from "./btnMyTeam.ts?vue&type=script&lang=ts&external"
export * from "./btnMyTeam.ts?vue&type=script&lang=ts&external"
import style0 from "./BtnMyTeam.vue?vue&type=style&index=0&id=045a65db&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a65db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045a65db')) {
      api.createRecord('045a65db', component.options)
    } else {
      api.reload('045a65db', component.options)
    }
    module.hot.accept("./BtnMyTeam.vue?vue&type=template&id=045a65db&scoped=true", function () {
      api.rerender('045a65db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/btn-my-team/BtnMyTeam.vue"
export default component.exports